@if (averageRegistrationStatusTimes?.count! > 0) {
  <div
    id="divChart"
    class="chart-container"
    >
    <canvas id="averageRegistrationStatusTimes"></canvas>
  </div>
}
